import React, { useState } from "react";
import {
  Box,
  Container,
  CssBaseline,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  OutlinedInput,
  ThemeProvider,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import theme from "../../config/theme";
import config from "../../config";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import SquareIcon from "@mui/icons-material/Square";
import { useForm } from "react-hook-form"
import { StyledButton } from "./Button";
import { StyledFormControl } from "./FormControl";
import x from "../../assets/x.svg";
import linkedin from "../../assets/linkedin.svg";
import facebook from "../../assets/facebook.svg";
import github from "../../assets/github.svg";
import { NavLink, Link } from "react-router-dom";

const StyledBox = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingTop: "5rem",
});

const navLinks = [
  {
    title: "Product",
    links: [
      { title: "Home", path: "/" },
      { title: "Ledger", path: "/ledger" },
      { title: "Docket", path: "/docket" },
      { title: "Bite", path: "/bite" },
      { title: "Plans", path: "/plans" },
      { title: "Get In Touch", path: "/contact" },
    ],
  },
  {
    title: "Quicklinks",
    links: [
      { title: "Privacy policy", path: "/privacy" },
      { title: "Terms", path: "/terms" },
      { title: "Cookies", path: "/cookies" },
      { title: "Licenses", path: "/licenses" },
      { title: "Blogs", path: "/blogs" },
    ],
  },
  {
    title: "Social Links",
    links: [
      { title: "Twitter", path: "https://twitter.com/youstad" },
      { title: "LinkedIn", path: "https://www.linkedin.com/youstad" },
      { title: "Facebook", path: "https://www.facebook.com/youstad" },
      { title: "Github", path: "https://github.com/youstad" },
    ],
  },
  {
    title: "Address",
    links: [
      {
        title: [
          // "Lorem ipsum dolor sit amet,",
          // <br />,
          // "consectetur adipiscing elit,",
          // <br />,
          // "sed do lor",
        ],
        path: "#",
      },
    ],
  },
];

const socialIcons = [
  { img: x, title: "Twitter", path: "https://twitter.com/youstad" },
  { img: linkedin, title: "LinkedIn", path: "https://www.linkedin.com/youstad" },
  { img: facebook, title: "Facebook", path: "https://www.facebook.com/youstad" },
  { img: github, title: "Github", path: "https://github.com/youstad" },
]

const generateNavLinks = () => {
  return navLinks.map((navLink) => (
    <Box sx={{ flex: "1 0" }}>
      <List>
        <Typography
          variant="h4"
          sx={{
            color: ["#FFFFFF", "#AAAAAA"],
            fontSize: ["0.625rem", "1.125rem"],
            fontWeight: [400, 700],
            letterSpacing: ["0.009375rem", "0.0071986875"],
            lineHeight: ["1.125rem", "1.5rem"],
            marginBottom: ["0.5rem", "2.5rem"],
          }}
        >
          {navLink.title}
        </Typography>

        {navLink.links.map((link) => (
          <ListItem key={link.title} disablePadding>
            <ListItemButton component={NavLink} to={link.path}>
              <ListItemIcon>
                <Typography
                  component="div"
                  sx={{
                    color: "#FFFFFF",
                    fontSize: ["0.5rem", "0.8125rem"],
                    fontWeight: 700,
                    letterSpacing: ["0.0532384375rem", "0.078125rem"],
                    lineHeight: ["0.6875rem", "1.5rem"],
                  }}
                >
                  {link.title}
                </Typography>
              </ListItemIcon>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  ));
};

const Footer = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()
  const [loading, setLoading] = useState(false)

  const relayToFormspree = async (data) => {
    setLoading(true)
    console.log(data)
    axios
    .post(config.newsletterLink, {
      ...data,
    })
    .then(() => {
      toast.success("Thank you for subscribing!")
      reset()
    })
    .catch((err) =>
      toast.error(err?.response?.data?.error || "Something went wrong")
    )
    .finally(() => setLoading(false))
  }
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ backgroundColor: "black" }}>
        {isMobile ? (
          <Container>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography
                variant="h4"
                sx={{
                  marginTop: "2.5rem",
                  fontSize: "1rem",
                  fontWeight: 700,
                  letterSpacing: "0.01199775rem",
                  color: "#FFFFFF",
                }}
              >
                Signup to our newsletter
              </Typography>

              <Typography
                variant="h4"
                sx={{
                  marginTop: "0.25rem",
                  fontSize: "0.625rem",
                  letterSpacing: " 0.0071986875rem",
                  color: "#FFFFFF",
                  whiteSpace: "nowrap",
                }}
              >
                Stay up to date with our latest news, announcements and articles
              </Typography>
            </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.921875rem",
                  marginTop: "0.5rem",
                }}
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={handleSubmit(relayToFormspree)}
              >
                <StyledFormControl
                  height="1.546875rem"
                  width="10.828125rem"
                  background="#EEF6FF"
                  border="0.515625px solid #6A6A6A"
                  borderRadius="0.2578125rem"
                  padding="0.3rem"
                >
                  <OutlinedInput
                    placeholder="Email ID"
                    sx={{
                      fontWeight: 400,
                      fontSize: "0.625rem",
                      letterSpacing: "0.0048339875rem",
                    }}
                    {...register("email", {
                      required: "This field is required",
                      pattern: {
                        value:
                          /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                        message: "Please provide a valid email",
                      },
                    })}
                  />
                  <Typography variant="body1" color="error">{errors.email?.message}</Typography>
                </StyledFormControl>
                <StyledButton
                  disabled={loading}
                  type="submit"
                  variant="contained"
                  height="1.5rem"
                  width="4.625rem"
                  style={{
                    borderRadius: "1.022175rem",
                    backgroundColor: `${theme.palette.primary.main}`,
                  }}
                >
                  <Typography sx={{ fontSize: "0.5rem" }}>{loading ? "Subscribing..." : "Subscribe"}</Typography>
                </StyledButton>
              </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: "2.515625rem",
              }}
            >
              {generateNavLinks()}
            </Box>

            <Box>
              <HorizontalRuleIcon
                style={{
                  marginTop: "1.25rem",
                  width: "100%",
                  height: "0.0625rem",
                  backgroundColor: "#D9D9D9",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1.25rem",
                paddingBottom: "1.75rem",
                gap: "0.5rem",
              }}
            >
             {socialIcons.map((socialIcon) => (
                <Link to={socialIcon.path} target="_blank">
                <img
                  src={socialIcon.img}
                  alt={socialIcon.title}
                  style={{ width: "0.75rem", height: "0.75rem" }}
                />
                </Link>
              ))}
            </Box>
          </Container>
        ) : (
          <Container>
            <StyledBox>
              <Typography
                variant="h4"
                sx={{
                  fontSize: "2rem",
                  fontWeight: "700",
                  letterSpacing: "0.015625rem",
                  color: "#FFFFFF",
                }}
              >
                Signup to our newsletter
              </Typography>

              <Box
                sx={{ display: "flex", alignItems: "center", gap: "1.125rem" }}
                component="form" noValidate autoComplete="off"
                onSubmit={handleSubmit(relayToFormspree)}
              >
                <StyledFormControl
                  height="3rem"
                  width="15.5rem"
                  background="#EEF6FF"
                  border="1px solid #6A6A6A"
                  padding="0.75rem 5.625rem 0.75rem 1rem"
                >
                  <OutlinedInput
                    placeholder="Enter your email"
                    {...register("email", {
                      required: "This field is required",
                      pattern: {
                        value:
                          /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                        message: "Please provide a valid email",
                      },
                    })}
                  />
                  <Typography variant="body1" color="error">{errors.email?.message}</Typography>
                </StyledFormControl>
                <StyledButton
                  disabled={loading}
                  type="submit"
                  variant="contained"
                  height="3rem"
                  width="9.875rem"
                  style={{
                    backgroundColor: `${theme.palette.primary.main}`,
                  }}
                >
                  {loading ? "Subscribing..." : "Subscribe"}
                </StyledButton>
              </Box>
            </StyledBox>

            <Box>
              <Typography
                variant="h4"
                style={{
                  marginTop: "1.6rem",
                  fontSize: "1.125rem",
                  letterSpacing: " 0.01rem",
                  color: "#FFFFFF",
                }}
              >
                Stay up to date with our latest news, announcements and articles
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                marginTop: "5rem",
              }}
            >
              {generateNavLinks()}
            </Box>

            <Box>
              <HorizontalRuleIcon
                style={{
                  marginTop: "1.25rem",
                  width: "100%",
                  height: "0.25rem",
                  border: "none",
                  backgroundColor: "#D9D9D9",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "1.25rem",
                paddingBottom: "3.75rem",
                gap: "0.75rem",
              }}
            >
              {socialIcons.map((socialIcon) => (
                <Link to={socialIcon.path} target="_blank">
                <img
                  src={socialIcon.img}
                  alt={socialIcon.title}
                  style={{ width: "1.25rem", height: "1.25rem" }}
                />
                </Link>
              ))}
            </Box>
          </Container>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default Footer;
